    <template>
  <div
    class="gallery--search col-xs-12 col-sm-6 col-sm-offset-6 col-md-8 col-md-offset-4 col-lg-4 col-lg-offset-8"
  >
    <i class="fa fa-search search-icon"></i>
    <input
      type="text"
      v-model="search"
      @keyup="searchQuery()"
      :placeholder="translations.search"
      clearable
    />
  </div>
</template>

<script lang="js">
import axios from "axios";

export default {

name: 'GallerySearch',
 props: [ "translations", "config", "dataResult", "showElements"],
  data() {
    return {
      search: "",
      currentPage: 1,
      list: {}
    };
  },
 methods: {
      refreshGalleryList() {
        const json = JSON.stringify(this.dataResult);
        const url = this.config.filter + '?language=' + this.config.language +'&size='+ this.showElements;
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };
        console.log('refreshGalleryList');
        axios.post(url, json, config)
        .then(response => {
            this.list = response.data.gallerieSearchList;
            this.$emit('update-gallery', this.list, response.data.totalPages);
            console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    searchQuery() {

     this.dataResult.searchPhrase = this.search;

      if (this.search.length > 2) {
       // this.$store.dispatch("searchQuery", this.search);

        this.refreshGalleryList();
       //console.log(this.dataResult);
      } else {
       // this.$store.dispatch("loadExhibitors", 1);
       this.dataResult.searchPhrase = '';
       this.refreshGalleryList();
      }

    }

 }
};
</script>
